import { AxiosResponse } from 'axios'
import { apiNode } from './api'
import { DefaultGetParamsProps } from './types/interfaces'
import events from '../../pages/MySpace/CalendarPage/test-data.json'
import {
	CalendarEvent,
	CalendarEventsListItem,
	GetCalendarEventsParamsProps,
	GetCalendarEventsResponseData,
	GetCalendarEventResponseData,
	UpdateCalendarEvent,
} from './types/calendar.interfaces'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

const URL = '2/calendar'

export const CalendarService = {
	async getEvents({
		startDate,
		endDate,
	}: GetCalendarEventsParamsProps): Promise<GetCalendarEventsResponseData> {
		// const response: AxiosResponse<unknown> = await apiNode.get<unknown>(
		// 	`${URL}`,
		// )
		// return response.data

		// Filter events by date range and map to CalendarEventsListItem
		let filteredEvents = events as CalendarEvent[]

		if (startDate || endDate) {
			filteredEvents = events.filter((event) => {
				return event.occurrences.some((occurrence) => {
					const occurrenceStart = dayjs(occurrence.startDate)
					const occurrenceEnd = dayjs(occurrence.endDate)

					const start = startDate
						? dayjs(startDate)
						: dayjs().subtract(1, 'year')
					const end = endDate ? dayjs(endDate) : dayjs().add(1, 'year')

					return (
						occurrenceStart.isSameOrBefore(end, 'day') &&
						occurrenceEnd.isSameOrAfter(start, 'day')
					)
				})
			}) as CalendarEvent[]
		}

		// Map to CalendarEventsListItem format
		const eventsList: CalendarEventsListItem[] = filteredEvents.map(
			(event) => ({
				id: event.id,
				title: event.title,
				isPersonal: event.isPersonal,
				repeatType: event.repeatType,
				occurrences: event.occurrences,
			})
		)

		return {
			data: eventsList,
			success: true,
		}
	},
	async getEventById({
		id,
	}: DefaultGetParamsProps): Promise<GetCalendarEventResponseData> {
		// const response: AxiosResponse<unknown> = await apiNode.get<unknown>(
		// 	`${URL}/${id}`,
		// )
		// return response.data

		// Find and return full event by ID (simulating backend)
		const event = events.find((event) => event.id === id) as CalendarEvent

		if (!event) {
			throw new Error('Event not found')
		}

		return {
			data: event,
			success: true,
		}
	},
	async createEvent({ data }: { data: any }) {
		return apiNode.post(`${URL}/create`, data)
	},
	async updateEvent({
		data,
		id,
	}: {
		data: UpdateCalendarEvent
		id: string
	}) {
		return apiNode.patch(`${URL}/${id}/update`, data)
	},
	async deleteEvent({ id }: DefaultGetParamsProps) {
		return apiNode.delete(`${URL}/${id}/delete`)
	},
}
